module.exports = __webpack_public_path__ + "static/media/2.738e628a.png";